export const urszulaSzulc = {
    'meta': {
        'title': 'Psychiatra Urszula Szulc • Centrum COLLIGO',
        'description': 'Jestem lekarzem ze specjalizacją z psychiatrii dorosłych. Studia medyczne ukończyłam na Wydziale Lekarskim I Uniwersytetu Medycznego w Poznaniu.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-urszula-szulc/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/urszula-szulc.webp',
            'width': 150,
            'height': 150,
            'alt': 'Lekarz Urszula Szulc'
        }
    }
}